import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { getAssignmentTiming, startAssignment } from "../../services/camunda.service";
import { assignmentClosed, deadlineDate, deadlineHour } from "../../services/assignmentDeadline";

export default function AssignmentTimerGate({ taskId, initialState, onBack, children }) {
  const [timing, setTiming] = useState(null);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState("");
  const [now, setNow] = useState(Date.now());
  const mounted = useRef(false);
  const flight = useRef(false);
  const load = useCallback(async (start = false) => {
    if (flight.current) return;
    flight.current = true; setBusy(true); setError("");
    try {
      const value = await (start ? startAssignment(taskId) : getAssignmentTiming(taskId));
      if (start && value.timeLimitMinutes && (!value.startedAt || !value.timerExpiresAt)) throw new Error("Invalid timer");
      if (mounted.current) setTiming(value);
    } catch (failure) {
      if (mounted.current) setError([403, 404, 410].includes(failure?.response?.status)
        ? "Esta evaluación ya no está disponible para responder. Vuelve a tus asignaciones para consultar su estado."
        : "No se pudo confirmar el temporizador. Reintenta para recuperar su estado sin reiniciar el tiempo.");
    } finally { flight.current = false; if (mounted.current) setBusy(false); }
  }, [taskId]);
  useEffect(() => {
    mounted.current = true; load();
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => { mounted.current = false; clearInterval(timer); };
  }, [load]);
  const state = { ...initialState, ...timing };
  if (timing && (timing.startedAt || !timing.timeLimitMinutes)) return children(state);
  const closed = timing && assignmentClosed(state, now);
  return <div className="assignment-player teamassess-form">
    <header className="player-header"><Button text icon="pi pi-arrow-left" label="Mis asignaciones" onClick={onBack} disabled={busy} /></header>
    <section className="player-timer-gate" aria-busy={busy}>
      <i className="pi pi-clock player-start-icon" aria-hidden="true" />
      <h1>{initialState.questionnaireName || "Evaluación"}</h1>
      {timing && <>
        <dl className="player-start-details">
          <div><dt>Duración máxima</dt><dd>{timing.timeLimitMinutes} minutos</dd></div>
          {initialState.dueAt && <div><dt>{initialState.hardDeadline ? "Cierre definitivo" : "Fecha de entrega"}</dt>
            <dd>{deadlineDate(initialState)} · {deadlineHour(initialState)}</dd></div>}
        </dl>
        <p>Al iniciar, el tiempo seguirá corriendo aunque salgas o recargues. Cuando termine, se enviarán tus respuestas, incluso si quedan preguntas vacías.</p>
        {initialState.hardDeadline && <p>Si llega antes la fecha de cierre definitivo, la evaluación se cerrará en ese momento.</p>}
      </>}
      {closed && <p role="status">El plazo de esta evaluación ya terminó.</p>}
      {error && <p className="ta-field-error" role="alert">{error}</p>}
      {busy ? <p role="status">{timing ? "Iniciando evaluación..." : "Consultando tiempo disponible..."}</p>
        : error ? <Button label="Reintentar" icon="pi pi-refresh" onClick={() => load()} />
          : !closed && <Button label="Iniciar evaluación" icon="pi pi-play" onClick={() => load(true)} />}
    </section>
  </div>;
}
